<template lang="html">
  <div class="bill-search-form-wrapper">
    <el-radio-group
      v-model="ruleForm.billType"
      class="radio-group-wrapper"
      @change="doReset"
    >
<!--      <el-radio-button :label="1">新账单</el-radio-button>-->
<!--      <el-radio-button :label="2">旧账单</el-radio-button>-->
    </el-radio-group>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width=""
      class="bill-search-form"
    >
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item label="" prop="receiptAndPaymentStatus">
            <el-select
              v-model="ruleForm.receiptAndPaymentStatus"
              placeholder="请选择收付状态"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="" prop="createTime">
            <el-date-picker
              v-model="ruleForm.createTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              value-format="timestamp"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-row>
            <el-col :span="11">
              <el-form-item label="" prop="realTotalMoney.start">
                <el-input
                  v-model="ruleForm.realTotalMoney.start"
                  type="number"
                  placeholder="最小金额"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" class="join-line-wrap">
              <span class="join-line">--</span>
            </el-col>
            <el-col :span="11">
              <el-form-item label="" prop="realTotalMoney.end">
                <el-input
                  v-model="ruleForm.realTotalMoney.end"
                  type="number"
                  placeholder="最大金额"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-button type="default" @click="doReset">重置</el-button>
          <el-button type="primary" @click="doSearch">搜索</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    ruleForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rules: {},
      options: [
        {
          label: "全部",
          value: -1
        },
        {
          label: "未收付",
          value: 0
        },
        {
          label: "收付中",
          value: 1
        },
        {
          label: "已收付",
          value: 2
        }
      ]
    };
  },
  computed: {},
  created() {},
  methods: {
    doReset() {
      this.$refs.ruleForm.resetFields();
      this.$emit("search");
    },
    doSearch() {
      this.$emit("search");
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="scss" scoped>
.bill-search-form-wrapper {
  .radio-group-wrapper {
    margin-top: 20px;
  }
  .bill-search-form {
    margin-top: 20px;
    .join-line-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 34px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/bill/components/searchForm/index.vue